/** @namespace Accounting */
NS("Accounting");

/**
 * @class
 */
Accounting.Security = Static(/** @lends Accounting.Security */{
    /**
     * Checks if current user has access to the item (takes into account ACL options of item).
     *
     * @param {Object} item Acl item
     * @param {string} key
     * @param {number | number[]} access
     * @param {number | number[]} [aclAction]
     *
     * @returns {boolean} Returns true if user has access to security key and
     *                    user is owner of item or item is public, or user satisfies ACL filters
     */
    checkItemAccess(item, key, access, aclAction) {
        return check(key, access);
    },
    /**
     * Verifies if user has access.
     *
     * @param {Object} item Acl item
     * @param {string} key
     * @param {number | number[]} access
     * @param {number | number[]} [aclAction]
     *
     * @returns {boolean} Returns true if user has access to security key and
     *                    user is owner of item or item is public, or user satisfies ACL filters
     *
     * @throws AccessDeniedError
     */
    verifyItemAccess(item, key, access, aclAction) {
        if (!this.checkItemAccess(item, key, access, aclAction)) {
            throw new AccessDeniedError('Access denied');
        }

        return true;
    },
    /**
     * Checks if current user has access to the item (takes into account ACL options of item).
     *      Calls alert on false.
     *
     * @param {Object} item Acl item
     * @param {string} key
     * @param {number | number[]} access
     * @param {number | number[]} [aclAction]
     *
     * @returns {boolean} Returns true if user has access to security key and
     *                    user is owner of item or item is public, or user satisfies ACL filters
     */
    checkItemAccessNotify(item, key, access, aclAction) {
        if (!this.checkItemAccess(item, key, access, aclAction)) {
            alert("Доступ запрещен");

            return false;
        }

        return true;
    }
});
